package org.tlsys.api.core2

object Reports {
    const val TRANSACTIONS = "/capi/v1/reports/transactions"
}
